/**
 * 지점이 많은 상품(캠핑 장비 113곳 등)의 "이용 가능 지역" 모드 판정과 큰 지도 링크.
 *
 * 상세 위치 섹션(BranchCoverage)과 모바일 플로팅 지도 버튼이 같은 기준을 써야 해서
 * 여기 한 곳에 둔다. ProductBranches 는 Maps 때문에 dynamic import 되므로
 * 그 파일에서 상수를 꺼내 쓰면 안 된다(초기 번들로 끌려 들어온다).
 */

import { partnerScopeHref } from "@/lib/search/search-url";

/**
 * 물리 지점이 이 수 이상이면 커버리지 모드(지역 칩·목록 + 플로팅 지도 버튼).
 * 그 아래는 기존 LocationMap(칩 + 선택 지점 주소). 사용자 결정(10-14)으로 20 —
 * prod 기준 fantory(콘서트장 14~16곳)는 기존 화면, hinata 캠핑·bestbike 대형 상품만 해당.
 */
export const COVERAGE_MIN_BRANCHES = 20;

/** 캠핑(10-04) 하위 상품이면 "캠핑장" 문구를 쓴다. */
export function isCampingCategory(categoryCode?: string | null): boolean {
  return !!categoryCode && (categoryCode === "10-04" || categoryCode.startsWith("10-04-"));
}

/** 물리 지점(배송 전용 제외) 수 기준 판정. */
export function isCoverageMode(
  branches: Array<{ branch_type?: string | null }> | null | undefined,
): boolean {
  if (!branches) return false;
  const physical = branches.filter((b) => b.branch_type !== "delivery").length;
  return physical >= COVERAGE_MIN_BRANCHES;
}

/**
 * 검색 페이지(큰 지도) — 이 파트너 + 이 상품 카테고리, 이 상품을 목록 맨 앞에.
 * 카테고리만 넘기면 다른 업체 상품까지 섞여 "이 상품을 쓸 수 있는 곳"이 흐려진다.
 */
export function buildBigMapHref(
  locale: string,
  partnerSlug?: string | null,
  categoryCode?: string | null,
  productId?: string,
): string | null {
  if (!partnerSlug) return null;
  return partnerScopeHref(locale, partnerSlug, {
    categories: categoryCode ?? undefined,
    // 검색 목록에서 지금 보던 상품 카드를 맨 앞에
    pin: productId,
  });
}
